import React from "react";
import { Row, Col } from "react-bootstrap";
import Adminsidebar from "../../components/admin/AdminSidebar/Adminsidebar";
import "../../assests/css/admin/Adminmasterlayout.css";

const Adminmasterlayout = ({ children }) => {
  return (
    <div className="admin-master-layout">
      <Row className="g-0">
        <Col className="sidebar-col">
          <Adminsidebar />
        </Col>
        <Col className="content-col">
          {children}
        </Col>
      </Row>
    </div>
  );
};

export default Adminmasterlayout;